export default "__VITE_ASSET__BxeR2NTr__"